import { k as e, d as r, i as m, j as t } from "./variables-dP5qqrAo.js";
var E = ((a) => (a[a.DEFAULT = parseInt(e, 10)] = "DEFAULT", a[a.MEDIUM = parseInt(r, 10)] = "MEDIUM", a[a.LARGE = parseInt(m, 10)] = "LARGE", a[a.XLARGE = parseInt(t, 10)] = "XLARGE", a))(E || {});
export {
  E as B
};
